// extracted by mini-css-extract-plugin
module.exports = {"bottomSpaced":"Layout_bottomSpaced__1qYFE"};